import React from 'react';
import classnames from 'classnames';
import Text from '../../../../global/text/text';
import ChevronSVG from '../../../../../images/svg/icons8-expand-arrow';
import './link-item.scss';

type Props = {
    isOpen: boolean;
    label?: string;
    type?: string;
    url?: string;
    isEventTrackerForm?: boolean;
    isMeetingLink?: boolean;
};

export const LinkItemLabel = React.forwardRef((props: Props, ref: React.Ref<HTMLInputElement>) => {
    const { isOpen, label = '', type = '', url = '', isEventTrackerForm = false, isMeetingLink = false } = props;
    return (
        <div
            ref={ref}
            className={classnames('event-link__item-label', { 'event-link__item-label--active': isOpen, 'disabled': isEventTrackerForm })}
        >
            <Text tag='div' message={label || (isMeetingLink ? url : type)} withEllipsis />
            {!isEventTrackerForm && <span className='attendee-button__chevron'>
                <ChevronSVG />
            </span>
            }
        </div>
    );
});
